import { IContentInfo } from '../../ts/models/IContentInfo';

export enum DraggableItemType {
  Card = 'card',
}

export interface CardItemType {
  type: string;
  index: number;
  row: number;
  content: IContentInfo;
  startIndex?: number;
}
